export const handleOriginalImage = (original_image) => original_image;
